"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketActivityApply = require("@/api/marketActivityApply");
var _marketActivity = require("@/api/marketActivity");
var _permission = require("@/utils/permission");
var _marketActivityRefund = require("@/utils/marketActivityRefund");
var _debounce = _interopRequireDefault(require("@/libs/debounce"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MarketActivityApplyList',
  data: function data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      detailLoading: false,
      activeTab: '0',
      detailDrawer: false,
      auditDialog: false,
      spreadAuditDialog: false,
      currentDetail: null,
      detailRequestId: 0,
      refundLoadingId: null,
      refundLockedApplyIds: [],
      activityOptions: [],
      collapse: false,
      labelPosition: 'right',
      spreadDetail: null,
      listQuery: {
        page: 1,
        limit: 20,
        activityId: '',
        goods: '',
        nickname: '',
        salesType: '',
        applyStatus: 0
      },
      auditForm: {
        id: null,
        applyStatus: 1,
        auditRemark: ''
      },
      auditRules: {
        applyStatus: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }]
      },
      spreadAuditForm: {
        id: null,
        applyId: null,
        spreadStatus: 3,
        spreadRemark: '',
        remarkFile: ''
      },
      spreadAuditRules: {
        spreadStatus: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    this.getList();
    this.getActivityOptions();
  },
  computed: {
    hasUserInfo: function hasUserInfo() {
      var _this = this;
      if (!this.currentDetail) return false;
      var detail = this.currentDetail;
      if (this.hasDisplayValue(detail.name)) return true;
      var keys = ['phone', 'wechat', 'idCard', 'address'];
      return keys.some(function (field) {
        return _this.hasDisplayValue(detail[field]);
      }) || this.idCardPhotos.length > 0 || this.wechatPhotos.length > 0;
    },
    hasApplyInfo: function hasApplyInfo() {
      var _this2 = this;
      if (!this.currentDetail) return false;
      var detail = this.currentDetail;
      var keys = ['activityName', 'needCount', 'goods', 'salesType', 'applyStatus', 'performanceBond', 'performancePayStatus', 'auditRemark', 'introduce', 'stallIntroduce', 'activityRecord', 'deviceInfo', 'maxKw', 'remark', 'updateTime'];
      return keys.some(function (field) {
        return _this2.hasDisplayValue(detail[field]);
      }) || this.businessFoodLicenseImages.length > 0 || this.healthCertificateImages.length > 0;
    },
    canViewSensitiveUserInfo: function canViewSensitiveUserInfo() {
      return !!this.currentDetail;
    },
    wechatPhotos: function wechatPhotos() {
      if (!this.currentDetail) return [];
      return this.parseImageList(this.currentDetail.wechatPhoto);
    },
    idCardPhotos: function idCardPhotos() {
      if (!this.currentDetail) return [];
      return this.parseImageList(this.currentDetail.idCardPhoto);
    },
    businessFoodLicenseImages: function businessFoodLicenseImages() {
      if (!this.currentDetail) return [];
      return this.parseImageList(this.currentDetail.businessFoodLicense);
    },
    healthCertificateImages: function healthCertificateImages() {
      if (!this.currentDetail) return [];
      return this.parseImageList(this.currentDetail.healthCertificate);
    },
    hasSpreadInfo: function hasSpreadInfo() {
      if (!this.spreadDetail || !this.spreadDetail.marketActivitySpreadRecord) return false;
      return true;
    },
    shouldShowSpreadAuditExtraFields: function shouldShowSpreadAuditExtraFields() {
      return Number(this.spreadAuditForm.spreadStatus) === 1;
    },
    spreadRemarkFiles: function spreadRemarkFiles() {
      if (!this.spreadDetail || !this.spreadDetail.marketActivitySpreadRecord) return [];
      return this.parseImageList(this.spreadDetail.marketActivitySpreadRecord.remarkFile);
    },
    spreadRemarkFileList: function spreadRemarkFileList() {
      return this.parseImageList(this.spreadAuditForm.remarkFile);
    },
    canRefundCurrentBond: function canRefundCurrentBond() {
      if (!this.currentDetail || this.refundLockedApplyIds.includes(this.currentDetail.id)) return false;
      return (0, _marketActivityRefund.canRefundPerformanceBond)(this.currentDetail);
    }
  },
  methods: {
    // 获取列表数据
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      var params = _objectSpread(_objectSpread({}, this.listQuery), {}, {
        applyStatus: parseInt(this.activeTab)
      });
      (0, _marketActivityApply.marketActivityApplyList)(params).then(function (response) {
        _this3.list = response.list || [];
        _this3.total = response.total || 0;
        _this3.listLoading = false;
      }).catch(function (error) {
        console.error('获取报名列表失败:', error);
        _this3.$message.error('获取数据失败');
        _this3.list = [];
        _this3.total = 0;
        _this3.listLoading = false;
      });
    },
    // 获取活动选项
    getActivityOptions: function getActivityOptions() {
      var _this4 = this;
      (0, _marketActivity.marketActivityList)({
        page: 1,
        limit: 1000,
        status: 0
      }).then(function (response) {
        _this4.activityOptions = response.list || [];
      }).catch(function (error) {
        console.error('获取活动列表失败:', error);
        _this4.$message.error('获取活动列表失败');
        _this4.activityOptions = [];
      });
    },
    // Tab切换
    handleTabClick: function handleTabClick(tab) {
      this.activeTab = tab.name;
      this.listQuery.page = 1;
      this.getList();
    },
    // 搜索
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 重置搜索
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        limit: 20,
        activityId: '',
        goods: '',
        nickname: '',
        salesType: '',
        applyStatus: parseInt(this.activeTab)
      };
      this.getList();
    },
    // 查看详情
    handleDetail: function handleDetail(row) {
      var _this5 = this;
      var requestId = ++this.detailRequestId;
      this.detailLoading = true;
      this.spreadDetail = null;
      this.currentDetail = null;
      this.detailDrawer = true;
      (0, _marketActivityApply.marketActivityApplyInfo)(row.id).then(function (response) {
        if (requestId !== _this5.detailRequestId || !_this5.detailDrawer) return;
        console.log('报名详情数据:', response);
        _this5.currentDetail = response;
        _this5.loadSpreadDetail(row.id);
        _this5.detailLoading = false;
      }).catch(function (error) {
        if (requestId !== _this5.detailRequestId || !_this5.detailDrawer) return;
        console.error('获取报名详情失败:', error);
        _this5.$message.error('获取详情失败');
        _this5.detailLoading = false;
      });
    },
    // 关闭详情抽屉
    handleDetailClose: function handleDetailClose() {
      this.detailRequestId += 1;
      this.detailDrawer = false;
      this.currentDetail = null;
      this.spreadDetail = null;
    },
    handleRefundPerformanceBond: function handleRefundPerformanceBond(detail) {
      var _this6 = this;
      if (!detail || this.refundLoadingId !== null) return;
      var applyId = detail.id;
      var bond = detail.performanceBond;
      this.$confirm("\u786E\u5B9A\u9000\u8FD8\u8BE5\u62A5\u540D\u7684\u5C65\u7EA6\u4FDD\u8BC1\u91D1 ".concat(bond, " \u5143\u5417\uFF1F"), '退还履约保证金', {
        confirmButtonText: '确定退还',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.refundLoadingId = applyId;
        return (0, _marketActivityApply.marketActivityApplyRefund)(applyId).then(function () {
          if (!_this6.refundLockedApplyIds.includes(applyId)) {
            _this6.refundLockedApplyIds.push(applyId);
          }
          if (_this6.currentDetail && _this6.currentDetail.id === applyId) {
            _this6.$set(_this6.currentDetail, 'performancePayStatus', 3);
          }
          _this6.$message.success('退款申请已提交');
          _this6.getList();
          _this6.refreshRefundDetail(applyId);
        }).catch(function (error) {
          console.error('退还履约保证金失败:', error);
          _this6.$message.error('退还履约保证金失败');
        }).finally(function () {
          if (_this6.refundLoadingId === applyId) _this6.refundLoadingId = null;
        });
      }).catch(function (action) {
        if (action !== 'cancel' && action !== 'close') {
          console.error('退款确认失败:', action);
        }
      });
    },
    refreshRefundDetail: function refreshRefundDetail(applyId) {
      var _this7 = this;
      (0, _marketActivityApply.marketActivityApplyInfo)(applyId).then(function (response) {
        var payStatus = Number(response && response.performancePayStatus);
        if (payStatus === 3 || payStatus === 4) {
          _this7.refundLockedApplyIds = _this7.refundLockedApplyIds.filter(function (id) {
            return id !== applyId;
          });
        }
        if (_this7.detailDrawer && _this7.currentDetail && _this7.currentDetail.id === applyId) {
          _this7.currentDetail = response;
        }
      }).catch(function (error) {
        console.error('退款后刷新报名详情失败:', error);
      });
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    // 审核
    handleAudit: function handleAudit(row) {
      this.auditForm = {
        id: row.id,
        applyStatus: 1,
        auditRemark: ''
      };
      this.auditDialog = true;
    },
    // 提交审核
    handleSubmitAudit: (0, _debounce.default)(function () {
      this.submitAudit();
    }, 500),
    submitAudit: function submitAudit() {
      var _this8 = this;
      this.$refs.auditForm.validate(function (valid) {
        if (valid) {
          var currentAuditId = _this8.auditForm.id;
          (0, _marketActivityApply.marketActivityApplyAudit)(_this8.auditForm).then(function (response) {
            _this8.$message.success('审核成功');
            _this8.auditDialog = false;
            // 清除弹窗内容
            _this8.clearAuditForm();
            _this8.getList();
            // 如果详情抽屉打开，刷新详情数据
            if (_this8.detailDrawer && _this8.currentDetail && _this8.currentDetail.id === currentAuditId) {
              _this8.handleDetail({
                id: currentAuditId
              });
            }
          }).catch(function (error) {
            console.error('审核失败:', error);
            _this8.$message.error('审核失败');
          });
        }
      });
    },
    // 取消审核
    cancelAudit: function cancelAudit() {
      this.auditDialog = false;
      this.clearAuditForm();
    },
    // 清除审核表单
    clearAuditForm: function clearAuditForm() {
      this.auditForm = {
        id: null,
        applyStatus: 1,
        auditRemark: ''
      };
      // 清除表单验证状态
      if (this.$refs.auditForm) {
        this.$refs.auditForm.resetFields();
      }
    },
    handleSpreadAudit: function handleSpreadAudit(row) {
      var _this9 = this;
      var applyId = row.id;
      (0, _marketActivityApply.marketActivityApplySpreadInfo)(applyId).then(function (response) {
        var spreadDetail = response && response.data ? response.data : response;
        _this9.spreadDetail = spreadDetail;
        var spreadRecord = spreadDetail && spreadDetail.marketActivitySpreadRecord ? spreadDetail.marketActivitySpreadRecord : null;
        if (!spreadRecord || !spreadRecord.id) {
          _this9.$message.error('未获取到推广审核记录ID');
          return;
        }
        _this9.spreadAuditForm = {
          id: spreadRecord.id,
          applyId: applyId,
          spreadStatus: 3,
          spreadRemark: '',
          remarkFile: ''
        };
        _this9.spreadAuditDialog = true;
      }).catch(function (error) {
        console.error('获取推广详情失败:', error);
        _this9.$message.error('获取推广详情失败');
      });
    },
    handleSubmitSpreadAudit: (0, _debounce.default)(function () {
      this.submitSpreadAudit();
    }, 500),
    submitSpreadAudit: function submitSpreadAudit() {
      var _this0 = this;
      this.$refs.spreadAuditForm.validate(function (valid) {
        if (valid) {
          var currentSpreadApplyId = _this0.spreadAuditForm.applyId;
          (0, _marketActivityApply.marketActivityApplySpreadAudit)(_this0.spreadAuditForm).then(function () {
            _this0.$message.success('推广审核成功');
            _this0.spreadAuditDialog = false;
            _this0.clearSpreadAuditForm();
            _this0.getList();
            if (_this0.detailDrawer && _this0.currentDetail && _this0.currentDetail.id === currentSpreadApplyId) {
              _this0.handleDetail({
                id: currentSpreadApplyId
              });
            }
          }).catch(function (error) {
            console.error('推广审核失败:', error);
            _this0.$message.error('推广审核失败');
          });
        }
      });
    },
    cancelSpreadAudit: function cancelSpreadAudit() {
      this.spreadAuditDialog = false;
      this.clearSpreadAuditForm();
    },
    clearSpreadAuditForm: function clearSpreadAuditForm() {
      this.spreadAuditForm = {
        id: null,
        applyId: null,
        spreadStatus: 3,
        spreadRemark: '',
        remarkFile: ''
      };
      if (this.$refs.spreadAuditForm) {
        this.$refs.spreadAuditForm.resetFields();
      }
    },
    loadSpreadDetail: function loadSpreadDetail(applyId) {
      var _this1 = this;
      (0, _marketActivityApply.marketActivityApplySpreadInfo)(applyId).then(function (response) {
        _this1.spreadDetail = response && response.data ? response.data : response;
      }).catch(function (error) {
        console.error('获取推广详情失败:', error);
        _this1.spreadDetail = null;
      });
    },
    openSpreadRemarkUpload: function openSpreadRemarkUpload() {
      var _this10 = this;
      var currentImages = this.spreadRemarkFileList;
      var remainingSlots = 9 - currentImages.length;
      this.$modalUpload(function (img) {
        if (!img) return;
        var newImages = img.map(function (item) {
          return item.sattDir;
        });
        var totalImages = currentImages.length + newImages.length;
        if (totalImages > 9) {
          _this10.$message.warning('最多只能上传9张图片，已自动截取前' + remainingSlots + '张');
          _this10.spreadAuditForm.remarkFile = JSON.stringify([].concat(_toConsumableArray(currentImages), _toConsumableArray(newImages.slice(0, remainingSlots))));
        } else {
          _this10.spreadAuditForm.remarkFile = JSON.stringify([].concat(_toConsumableArray(currentImages), _toConsumableArray(newImages)));
        }
      }, true, 'activity');
    },
    removeSpreadRemarkFile: function removeSpreadRemarkFile(index) {
      var images = _toConsumableArray(this.spreadRemarkFileList);
      images.splice(index, 1);
      this.spreadAuditForm.remarkFile = JSON.stringify(images);
    },
    getSpreadStatusText: function getSpreadStatusText(status) {
      var statusMap = {
        0: '待审核',
        1: '已失效',
        2: '结算中',
        3: '通过（已奖励）'
      };
      return statusMap[status] || '-';
    },
    formatTimeRange: function formatTimeRange(startTime, endTime) {
      if (!startTime || !endTime) return '暂无';
      var start = new Date(startTime).toLocaleString('zh-CN');
      var end = new Date(endTime).toLocaleString('zh-CN');
      return "".concat(start, " - ").concat(end);
    },
    getActivityApplyCount: function getActivityApplyCount(row) {
      if (!row) return 0;
      var applyCount = Number(row.applyCount);
      return Number.isNaN(applyCount) ? 0 : applyCount;
    },
    // 获取销售类型文本
    getSalesTypeText: function getSalesTypeText(type) {
      var types = {
        0: '美食',
        1: '文创',
        2: '游乐',
        3: '其他'
      };
      return types[type] || '-';
    },
    // 获取销售类型标签类型
    getSalesTypeTagType: function getSalesTypeTagType(type) {
      var types = {
        0: 'success',
        1: 'primary',
        2: 'warning',
        3: 'info'
      };
      return types[type] || 'info';
    },
    // 获取状态文本
    getStatusText: function getStatusText(status) {
      var statuses = {
        0: '待审核',
        1: '已通过',
        2: '未通过',
        3: '取消'
      };
      return statuses[status] || '-';
    },
    // 获取状态标签类型
    getStatusTagType: function getStatusTagType(status) {
      var types = {
        0: 'warning',
        1: 'success',
        2: 'danger',
        3: 'info'
      };
      return types[status] || 'info';
    },
    isPerformanceBondFree: function isPerformanceBondFree(row) {
      if (!row || !this.hasDisplayValue(row.performanceBond)) return false;
      var performanceBond = Number(row.performanceBond);
      return !Number.isNaN(performanceBond) && performanceBond === 0;
    },
    getPerformancePayStatusText: function getPerformancePayStatusText(row) {
      if (this.isPerformanceBondFree(row)) return '无需支付';
      var status = row ? Number(row.performancePayStatus) : undefined;
      var statuses = {
        0: '无需支付',
        1: '待支付',
        2: '已支付',
        3: '退款中',
        4: '已退款'
      };
      return statuses[status] || '-';
    },
    getPerformancePayStatusTagType: function getPerformancePayStatusTagType(row) {
      if (this.isPerformanceBondFree(row)) return 'info';
      var status = row ? Number(row.performancePayStatus) : undefined;
      var types = {
        0: 'info',
        1: 'warning',
        2: 'success',
        3: 'warning',
        4: 'info'
      };
      return types[status] || 'info';
    },
    // 获取商品图片数组
    getGoodsImages: function getGoodsImages(goodsImgStr) {
      return this.parseImageList(goodsImgStr);
    },
    // 解析图片字段
    parseImageList: function parseImageList(imageData) {
      if (!imageData) return [];
      var normalize = function normalize(arr) {
        return arr.map(function (item) {
          return typeof item === 'string' ? item.trim() : item;
        }).filter(function (item) {
          return item !== undefined && item !== null && String(item).trim() !== '';
        });
      };
      if (Array.isArray(imageData)) {
        return normalize(imageData);
      }
      if (typeof imageData === 'string') {
        var trimmed = imageData.trim();
        if (!trimmed) return [];
        try {
          var parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return normalize(parsed);
          }
        } catch (error) {
          // ignore parse errors
        }
        if (trimmed.includes(',')) {
          return normalize(trimmed.split(','));
        }
        return normalize([trimmed]);
      }
      return [];
    },
    // 判断字段是否有展示值
    hasDisplayValue: function hasDisplayValue(value) {
      var _this11 = this;
      if (Array.isArray(value)) {
        return value.some(function (item) {
          return _this11.hasDisplayValue(item);
        });
      }
      return value !== undefined && value !== null && String(value).trim() !== '';
    },
    hasPromotionAudit: function hasPromotionAudit(row) {
      if (!row) return false;
      var promotion = Number(row.promotion);
      return Number(row.applyStatus) === 1 && !Number.isNaN(promotion) && promotion > 0;
    },
    // 添加报名
    handleAdd: function handleAdd() {
      this.$router.push('/market/activity/apply/add');
    },
    // 编辑报名
    handleEdit: function handleEdit(row) {
      this.$router.push({
        path: '/market/activity/apply/edit',
        query: {
          id: row.id
        }
      });
    },
    // 权限检查
    checkPermi: function checkPermi(permissions) {
      return (0, _permission.checkPermi)(permissions);
    }
  }
};